import React, { useEffect, useState } from 'react';
import Hero from '../components/Hero';
import Services from '../components/Services';
import Portfolio from '../components/Portfolio';
import Testimonials from '../components/Testimonial';
import NewsBlogs from '../components/NewsBlogs';
const Home = () => {
  const [showPopup, setShowPopup] = useState(false);
  const [typedText, setTypedText] = useState('');
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    interest: '',
    message: ''
  });
  const [formStatus, setFormStatus] = useState(''); // 'success', 'error', 'sending'

  const fullText = "Hey there! Looking for something special? Let's chat!";

  useEffect(() => {
    const popupTimer = setTimeout(() => {
      setShowPopup(true);
      startTypingEffect();
    }, 5000);

    return () => clearTimeout(popupTimer);
  }, []);

  useEffect(() => {
    if (formStatus === 'success') {
      const timer = setTimeout(() => {
        setShowPopup(false);
        setFormStatus('');
      }, 10000); // Changed from 2000ms to 10000ms (10 seconds)
      return () => clearTimeout(timer);
    }
  }, [formStatus]);

  const startTypingEffect = () => {
    let i = 0;
    const typingInterval = setInterval(() => {
      if (i < fullText.length) {
        setTypedText(fullText.substring(0, i + 1));
        i++;
      } else {
        clearInterval(typingInterval);
      }
    }, 30);
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setFormStatus('sending');

    try {
      const response = await fetch('https://vibex.media/api/inquryForm.php', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: new URLSearchParams({
          ...formData,
          'submit': 'true'
        }).toString()
      });

      const result = await response.json();

      if (response.ok && result.success) {
        setFormStatus('success');
        setFormData({
          name: '',
          email: '',
          interest: '',
          message: ''
        });
      } else {
        throw new Error(result.error || 'Failed to send message');
      }
    } catch (error) {
      console.error('Error:', error);
      setFormStatus('error');
    }
  };

  const closePopup = () => {
    setShowPopup(false);
    setFormStatus('');
  };

  return (
    
    <>
      <Hero />
      <Services />
      <Portfolio />
      <NewsBlogs />
      <Testimonials />

      {showPopup && (
        <div className="modern-popup-overlay">
          <div className="modern-popup-container">
            <div className="popup-content">
              <div className="character-section">
                <div className="character-avatar">
                  <img
                    src="https://cdn-icons-png.flaticon.com/512/4202/4202843.png"
                    alt="Assistant"
                    className="avatar-img"
                  />
                </div>
                <div className="character-message">
                  <div className="speech-bubble">
                    <p className="typing-text">{typedText}<span className="cursor">|</span></p>
                  </div>
                </div>
              </div>

              <form className="modern-inquiry-form" onSubmit={handleSubmit}>
                <h3 className="form-title">How Can We Help You?</h3>

                {formStatus === 'success' ? (
                  <div className="form-success">
                    <svg width="48" height="48" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M22 11.08V12C21.9988 14.1564 21.3005 16.2547 20.0093 17.9818C18.7182 19.7088 16.9033 20.9725 14.8354 21.5839C12.7674 22.1953 10.5573 22.1219 8.53447 21.3746C6.51168 20.6273 4.78465 19.2461 3.61096 17.4371C2.43727 15.628 1.87979 13.4881 2.02168 11.3363C2.16356 9.18455 2.99721 7.13631 4.39828 5.49706C5.79935 3.85781 7.69279 2.71537 9.79619 2.24013C11.8996 1.7649 14.1003 1.98232 16.07 2.86" stroke="#4CAF50" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                      <path d="M22 4L12 14.01L9 11.01" stroke="#4CAF50" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                    </svg>
                    <p>Message sent successfully! We'll contact you soon.</p>
                    <button
                      type="button"
                      className="close-success-button"
                      onClick={closePopup}
                    >
                      Close
                    </button>
                  </div>
                ) : formStatus === 'error' ? (
                  <div className="form-error">
                    <svg width="48" height="48" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M12 8V12V8ZM12 16H12.01H12ZM21 12C21 13.1819 20.7672 14.3522 20.3149 15.4442C19.8626 16.5361 19.1997 17.5282 18.364 18.364C17.5282 19.1997 16.5361 19.8626 15.4442 20.3149C14.3522 20.7672 13.1819 21 12 21C10.8181 21 9.64778 20.7672 8.55585 20.3149C7.46392 19.8626 6.47177 19.1997 5.63604 18.364C4.80031 17.5282 4.13738 16.5361 3.68508 15.4442C3.23279 14.3522 3 13.1819 3 12C3 9.61305 3.94821 7.32387 5.63604 5.63604C7.32387 3.94821 9.61305 3 12 3C14.3869 3 16.6761 3.94821 18.364 5.63604C20.0518 7.32387 21 9.61305 21 12Z" stroke="#F44336" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                    </svg>
                    <p>Failed to send message. Please try again later.</p>
                    <button
                      type="button"
                      className="submit-button"
                      onClick={() => setFormStatus('')}
                    >
                      Try Again
                    </button>
                  </div>
                ) : (
                  <>
                    <div className="form-group">
                      <input
                        type="text"
                        name="name"
                        placeholder="Your Name"
                        className="form-input"
                        value={formData.name}
                        onChange={handleInputChange}
                        required
                      />
                    </div>

                    <div className="form-group">
                      <input
                        type="email"
                        name="email"
                        placeholder="Email Address"
                        className="form-input"
                        value={formData.email}
                        onChange={handleInputChange}
                        required
                      />
                    </div>

                    <div className="form-group">
                      <select
                        name="interest"
                        className="form-input form-select"
                        value={formData.interest}
                        onChange={handleInputChange}
                      >
                        <option value="">What are you interested in?</option>
                        <option value="service">Our Services</option>
                        <option value="product">Our Products</option>
                        <option value="collab">Collaboration</option>
                        <option value="other">Other</option>
                      </select>
                    </div>

                    <div className="form-group">
                      <textarea
                        name="message"
                        placeholder="Tell us more about your needs..."
                        rows="4"
                        className="form-textarea"
                        value={formData.message}
                        onChange={handleInputChange}
                      ></textarea>
                    </div>

                    <div className="form-actions">
                      <button
                        type="button"
                        className="close-button"
                        onClick={closePopup}
                        disabled={formStatus === 'sending'}
                      >
                        Maybe Later
                      </button>
                      <button
                        type="submit"
                        className="submit-button"
                        disabled={formStatus === 'sending'}
                      >
                        {formStatus === 'sending' ? (
                          <>
                            <svg className="spinner" viewBox="0 0 50 50">
                              <circle cx="25" cy="25" r="20" fill="none" strokeWidth="5"></circle>
                            </svg>
                            Sending...
                          </>
                        ) : 'Send Message'}
                      </button>
                    </div>
                  </>
                )}
              </form>
            </div>

            <button
              className="modern-close-btn"
              onClick={closePopup}
              aria-label="Close popup"
              disabled={formStatus === 'sending'}
            >
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M18 6L6 18" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M6 6L18 18" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
              </svg>
            </button>
          </div>
        </div>
      )}
    </>
  );
};

export default Home;